import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-titulo',
  templateUrl: './titulo.component.html',
  styleUrls: ['./titulo.component.scss'],
})
export class TituloComponent implements OnInit {
  @Input() text: string = '';
  primaryColor: string = '';

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.primaryColor = 'var(--color-title-black)';
  }
}
